<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png" alt="IsoEvolve" height="50"
                 class="mr-0 lg:mr-6">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-sub-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-ellipsis-v text-2xl"></i>
                </a>
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
            <div id="navbar-sub-7"
                 class="hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                    <li>
                        <a @click="processConfiguration" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-cog text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Configuration</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processProfile" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-id-card text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Profile</span>
                        </a>
                    </li>
                    <li>
                        <a v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>
                            <span class="block lg:hidden font-medium">Notifications</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processLogout" v-tooltip="'Logout'" v-ripple
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-power-off text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Logout</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
        <div id="navbar-7"
             class="py-3 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 border-top-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverviewHome" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Overview</span>
                    </a>
                </li>
                <li>
                    <a @click="processClients" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Client Data</span>
                    </a>
                </li>
                <li>
                    <a @click="processCalendar" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-calendar mr-2"></i>
                        <span>Calendar</span>
                    </a>
                </li>
                <li>
                    <a @click="processProducts" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-tags mr-2"></i>
                        <span>Product Data</span>
                    </a>
                </li>
                <li v-show="((this.userStore.user.rights === 'A') || (this.userStore.user.rights === 'M')) ">
                    <a @click="processFinancial" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-money-bill mr-2"></i>
                        <span>Financial Data</span>
                    </a>
                </li>
                <li>
                    <a @click="processSearch" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-search mr-2"></i>
                        <span>Search</span>
                    </a>
                </li>
                <li>
                    <a @click="processApplications" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-shopping-cart mr-2"></i>
                        <span>Applications</span>
                    </a>
                </li>

                <li v-show="this.userStore.user.rights === 'S'">
                    <a @click="processAdmin" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-money-bill mr-2"></i>
                        <span>Admin</span>
                    </a>
                </li>

            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                // console.log("[MenuMain][mounted] System is active.");
                console.log("[MenuMain][mounted] Data = ", data);
            })
            .catch(e => {
                // console.log("[MenuMain][mounted] System is NOT active.");
                console.log("[MenuMain][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuMain][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        }
        // else {
        //     console.log("[MenuMain][mounted] User is defined. this.userStore.userId = ", this.userStore.userId);
        // }
    },
    data() {
        return {};
    },
    methods: {
        async processLogout() {
            console.log("[MenuSiModuleMain][processLogout] this.userStore.username = ", this.userStore.username);

            try {
                const responseData = await AuthenticationService.signoutUser(this.userStore.username);
                console.log('[MenuSiModuleMain][processLogout] Response = ', responseData);
            } catch (error) {
                console.error('[MenuSiModuleMain][processLogout] Error during signout:', error);
            }

            this.userStore.$reset();
            this.userStore.clearUser;
            window.location.href = "/#/login";
            window.location.reload();
        },
        processProfile() {
            console.log("[MenuMain][processProfile] Beginning.");
            window.location.href = "/#/commonProfile";
        },
        processConfiguration() {
            console.log("[MenuMain][processConfiguration] Beginning.");
            window.location.href = "/#/commonConfigurationBasic";
        },
        processOverviewHome() {
            console.log("[MenuMain][processOverviewHome] Beginning.");

            if (this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
                window.location.href = "/#/pmOverviewHome";
            } else if (this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)) {
                window.location.href = "/#/msOverviewHome";
            } else if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
                window.location.href = "/#/faOverviewHome";
            } else if (this.userStore.user.roles.includes('ROLE_ISOLEARN', 0)) {
                window.location.href = "/#/cpdOverviewHome";
            } else {
                window.location.href = "/#/sbOverviewHome";
            }

        },
        processClients() {
            console.log("[MenuMain][processClients] Beginning.");
            window.location.href = "/#/commonClients";
        },
        processCalendar() {
            console.log("[MenuMain][processCalendar] Beginning.");
            window.location.href = "/#/commonCalendar";
            // if (this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
            //     window.location.href = "/#/healthCalendar";
            // } else if (this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)) {
            //     window.location.href = "/#/healthCalendar";
            // } else {
            //     window.location.href = "/#/businessCalendar";
            // }
        },
        processProducts() {
            console.log("[MenuMain][processProducts] Beginning.");
            window.location.href = "/#/commonProducts";
        },
        processFinancial() {
            console.log("[MenuMain][processFinancial] Beginning.");

            window.location.href = "/#/commonFinancialInvoices";

            // if (this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
            //     window.location.href = "/#/healthFinancial";
            // } else if (this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)) {
            //     window.location.href = "/#/healthFinancial";
            // } else if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
            //     window.location.href = "/#/businessFinancial";
            // } else {
            //     window.location.href = "/#/businessFinancial";
            // }

        },
        processSearch() {
            console.log("[MenuMain][processSearch] Beginning.");
            window.location.href = "/#/commonSearch";

            // if (this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
            //     window.location.href = "/#/healthSearch";
            // } else if (this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)) {
            //     window.location.href = "/#/healthSearch";
            // } else if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
            //     window.location.href = "/#/businessSearch";
            // } else {
            //     window.location.href = "/#/businessSearch";
            // }

        },
        processApplications() {
            console.log("[MenuMain][processApplications] Beginning.");
            window.location.href = "/#/healthApplications";

            if (this.userStore.user.roles.includes('ROLE_ISOPRACTICE', 0)) {
                window.location.href = "/#/healthApplications";
            } else if (this.userStore.user.roles.includes('ROLE_ISOEVOLVE', 0)) {
                window.location.href = "/#/healthApplications";
            } else if (this.userStore.user.roles.includes('ROLE_ISOLEARN', 0)) {
                window.location.href = "/#/healthApplications";
            } else if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
                window.location.href = "/#/businessApplications";
            } else {
                window.location.href = "/#/businessApplications";
            }

        },
        processAdmin() {
            window.location.href = "/#/commonAdminOverview";
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
